import { gql, TypedDocumentNode } from "@apollo/client";

import { IntentProject, SearchSuggestionsInput } from "types/generated";

export const SEARCH_INTENT_RESOURCES_SUGGESTIONS: TypedDocumentNode<
  { intentProject: Pick<IntentProject, "id" | "searchIntentResourcesSuggestions"> },
  { intentProjectId: string; input: SearchSuggestionsInput }
> = gql`
  query SearchIntentResourcesSuggestions($intentProjectId: ID!, $input: SearchSuggestionsInput!) {
    intentProject(id: $intentProjectId) {
      id
      searchIntentResourcesSuggestions(input: $input) {
        filteredCount
      }
    }
  }
`;
